import { useGetSimListInfinite } from "@/services/api.ts";

import {
  getDefaultPortalSimListParams,
  portalSimListInfiniteQueryOptions,
} from "./usePortalSimListQuery.ts";

/**
 * Warms the React Query cache for the default Abos SIM list while the cockpit
 * is open, so navigating to My Subscriptions can reuse the first page fetch.
 */
export const usePrefetchPortalSimList = () => {
  useGetSimListInfinite(getDefaultPortalSimListParams(), {
    query: portalSimListInfiniteQueryOptions,
  });
};
